import { createFileRoute } from "@tanstack/react-router";
import { GuidanceListPage } from "../../../../components/system/GuidanceListPage";
import { requireSuperAdmin } from "../../../../lib/auth/route-protection";

export const Route = createFileRoute("/system/insights/guidance/")({
  beforeLoad: requireSuperAdmin(),
  component: GuidanceListPage,
});
